import { useMutation, useQueryClient } from '@tanstack/react-query'

import { request } from '../../../lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const setSelectedGoogleAccounts = (
  accountId: string,
  connectionId: number,
  adAccountsIds: number[]
) => {
  return request({
    url: `/accounts/${accountId}/google/${connectionId}/ad-accounts/selected`,
    method: 'PUT',
    data: { adAccountsIds },
  })
}

export const useSetSelectedGoogleAccounts = () => {
  const queryClient = useQueryClient()
  const { accountId } = useUserStore()
  return useMutation({
    mutationKey: ['setSelectedGoogleAccounts'],
    mutationFn: ({
      connectionId,
      adAccountsIds,
    }: {
      connectionId: number
      adAccountsIds: number[]
    }) => setSelectedGoogleAccounts(`${accountId}`, connectionId, adAccountsIds),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: ['getPlatformsConnections'] })
      void queryClient.invalidateQueries({ queryKey: ['googleAudiencesData'] })
      void queryClient.invalidateQueries({ queryKey: ['getPlatforms'] })
      void queryClient.invalidateQueries({ queryKey: ['getPlatformsGW'] })
      void queryClient.invalidateQueries({ queryKey: ['googleAdAccounts'] })
    },
  })
}
